import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {Link} from "react-router-dom";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {useHistory} from "react-router-dom";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Button, Card, Tabs, DataTable, FormField, Select} from "../UI";

const AreaList = props => {
    let history = useHistory();
    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [activeList, setActiveList] = useState([]);
    const [inactiveList, setInactiveList] = useState([]);
    const [tab, setTab] = useState("active");
    const [countries, setCountries] = useState([]);
    const [countryFilter, setCountryFilter] = useState("");
    const columns = [
        {
            name: 'Name',
            selector: 'title',
            sortable: true,
            cell: row => <div><Link to={"/areas/" + row.id}>{row.title}</Link></div>,
        },
        {
            name: 'Country',
            selector: 'country_name',
            sortable: true,
            cell: row => <span>{row.country_name || '—'}</span>,
        },
        {
            name: 'Centre Lat',
            selector: 'centre_lat',
        },
        {
            name: 'Centre Lng',
            selector: 'centre_lng',
        },
        {
            name: 'Radius in KM',
            selector: 'radius',
        }
    ]

    const applyFilter = list => countryFilter ? list.filter(a => a.country_id === countryFilter) : list;

    const load = (loadMore, status) => {
        let data = new FormData();
        data.append("status", status);
        setIsLoading(true);
        postData(Endpoints.AREA_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (status === 0) {
                    let currentPosts = loadMore ? activeList : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setActiveList(currentPosts);
                }

                if (status === 1) {
                    let currentPosts = loadMore ? inactiveList : [];
                    currentPosts = currentPosts.concat(...res.data);
                    setInactiveList(currentPosts);
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    const loadCountries = () => {
        postData(Endpoints.COUNTRY_LIST, new FormData())
            .then(res => res.json())
            .then(res => {
                if (res.success === 1 && Array.isArray(res.data)) {
                    setCountries(res.data);
                }
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        updateDocumentTitle("Areas")
        load(false, 1);
        load(false, 0);
        loadCountries();
    }, []);

    return (
        <PageLayout
            title="Areas"
            actions={
                <Link to="/areas/new">
                    <Button>Add new area</Button>
                </Link>
            }
        >
            <Tabs
                tabs={[
                    {key: "active", label: "Active", count: inactiveList.length},
                    {key: "inactive", label: "Inactive", count: activeList.length},
                ]}
                value={tab}
                onChange={setTab}
            />

            <div style={{maxWidth: 280, marginBottom: 12}}>
                <FormField label="Filter by country" flush>
                    <Select value={countryFilter} onChange={e => setCountryFilter(e.target.value)}>
                        <option value="">All countries</option>
                        {countries.map(c => (
                            <option key={c.id} value={c.id}>{c.name}</option>
                        ))}
                    </Select>
                </FormField>
            </div>

            <Card padded={false}>
                {tab === "active" &&
                <DataTable
                    columns={columns}
                    data={applyFilter(inactiveList)}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/areas/' + e.id);
                    }}
                />
                }
                {tab === "inactive" &&
                <DataTable
                    columns={columns}
                    data={applyFilter(activeList)}
                    progressPending={isLoading}
                    pointerOnHover={true}
                    noHeader={true}
                    onRowClicked={e => {
                        history.push('/areas/' + e.id);
                    }}
                />
                }
            </Card>
        </PageLayout>
    )
};

export default AreaList;
